module.exports = __webpack_public_path__ + "media/new/qr-icon-hover-ed5c7b41.svg";